import React, { memo, useEffect } from "react";
import styles from "../../ABheader.scss";
import { faHeaderNavClick } from "components/ABheader/services/ABheader.analytics";
import OutsideAlerter from "components/outsideAlerter";
const {
  menu_text,
  nav_text,
  navbar_right,
  open_dropdown,
  btn,
  login_user,
  other_user,
  user_icon,
  user_text,
  animated_arrow,
  cross_icon,
  user_account,
  account_list,
  bg_overlay,
} = styles;
export default function NavRightComponent({ nav_right, isUserDrawerOpen, setIsUserDrawerOpen, setShowTalkToAnExpert, onTalkToExpertClickCallback, flowName }) {

  const handleTalkToExpertClick = () => {
    setShowTalkToAnExpert(true);
    onTalkToExpertClickCallback && onTalkToExpertClickCallback();
  };

  const handleItemClick = () => {
    faHeaderNavClick({ flowName, segment: "signin" });
    setIsUserDrawerOpen(!isUserDrawerOpen);
  }

  return (
    <div className={`${navbar_right} ${isUserDrawerOpen ? open_dropdown : ""} `}>
      <button className={btn} onClick={handleTalkToExpertClick}>
        Talk To An Expert
      </button>
      <OutsideAlerter
        onOutsideClick={() => {
          setIsUserDrawerOpen(false);
        }}
      >
        <div className={login_user}>
          <div
            className={other_user}
            tabIndex={0}
            onKeyDown={(event) => {
              if (event.key === "Enter") {
                handleItemClick()
              }
            }}
            onClick={handleItemClick}
          >
            <svg className={user_icon} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path
                d="M15.4001 16.7502L15.4001 15.4002C15.4001 14.6841 15.1156 13.9974 14.6093 13.491C14.1029 12.9847 13.4162 12.7002 12.7001 12.7002L7.3001 12.7002C6.58401 12.7002 5.89726 12.9847 5.39091 13.491C4.88456 13.9974 4.6001 14.6841 4.6001 15.4002L4.6001 16.7502"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M10.0003 10.0001C11.4915 10.0001 12.7003 8.79127 12.7003 7.3001C12.7003 5.80893 11.4915 4.6001 10.0003 4.6001C8.50912 4.6001 7.30029 5.80893 7.30029 7.3001C7.30029 8.79127 8.50912 10.0001 10.0003 10.0001Z"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle cx="10" cy="10" r="9" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <span className={user_text}>Sign in</span>
            <span className={animated_arrow}></span>
            <i className={`${cross_icon} aeh-icon-Close`}></i>
          </div>
          <div className={user_account}>
            <ul className={account_list}>
              <NavRightDrawer nav_right={nav_right} flowName={flowName} />
            </ul>
          </div>
        </div>
      </OutsideAlerter>
    </div>
  );
}

const NavRightDrawer = memo(({ nav_right, flowName }) =>
  nav_right?.map((getNavRightData) => {
    let rightDataItems = getNavRightData?.otherNavigation?.map((setRightNavData, index) => {
      return (
        <li key={index}>
          <a
            className={menu_text}
            target={!setRightNavData.tabTarget === true ? "_self" : "_blank"}
            href={setRightNavData.linkUrl}
            onClick={(e) => faHeaderNavClick({ flowName: flowName, lob: setRightNavData.linkText, segment: "user navigation" })}
          >
            <span className={nav_text}>{setRightNavData.linkText}</span>
            {setRightNavData.tabTarget === true ? <i className="aeh-icon-direct-link"></i> : ""}
          </a>
        </li>
      );
    });
    return rightDataItems;
  }),
);
